<template lang="pug">
  section.slider-container(v-if="slides && slides.length" ref="container" :class="classes" :style="style")
    .slider(v-if="width" ref="slider" lazy-scroll-container)
      Slide(
        v-for="(slide, i) in slides" :key="slide.id"
        :slide="slide"
        :max-width="width"
        :max-height="height"
        :optimize="optimize"
        :style="{ width: `${slideWidth}%` }"
      )
</template>

<script>
import flickity from 'flickity';
import 'flickity/dist/flickity.min.css';
import 'flickity-fade';

import { get, cloneDeep, debounce } from '@/helpers';
import Slide from './Slide';

import section from '@/mixins/section';

export default {
  name: 'Slider',
  mixins: [section],
  data() {
    return {
      flickity: undefined,
      width: undefined
    };
  },
  props: {
    // slides: {
    //     type: Array,
    //     default: () => [],
    // },
    section: {
      type: Object,
      required: true
    }
  },
  components: {
    Slide
  },
  computed: {
    slides() {
      let slides = this.section.contents || [];
      return cloneDeep(slides).sort((a, b) => get(a, 'position', 0) - get(b, 'position', 0));
    },
    height() {
      let fr = 206;
      let height = 3 * fr;

      const config = this.settings.find(setting => setting.key === 'height');
      if (config && config.value) {
        switch (config.value) {
          case 'small':
            height = 1 * fr;
            break;

          case 'large':
            height = 3 * fr;
            break;
        }
      }

      return height;
    },
    animation() {
      let animation = 'slide';

      const config = this.settings.find(setting => setting.key === 'animation');
      if (config) animation = config.value;

      return animation;
    },
    optimize() {
      let optimize = 'traffic';

      const config = this.settings.find(setting => setting.key === 'optimize-images');
      if (config) optimize = config.value;

      return optimize;
    },

    slideFriction() {
        let friction = {
          selectedAttraction: 0.1,
          friction: 0.5
        };

        if (this.section.settings && this.section.settings.length) {
            const setting = this.section.settings.find(setting => setting.key === 'slide_friction');
            if (setting && setting.value !== undefined) friction = setting.value;
        }

        switch (friction) {
          case 'speed_fast':
            friction = {
              selectedAttraction: 0.2,
              friction: 0.8
            }
            break;

          case 'speed_slow':
            friction = {
              selectedAttraction: 0.01,
              friction: 0.15
            }
            break;
          default:
            friction = {
              selectedAttraction: 0.025,
              friction: 0.28
            }
        }

        return friction;
    },

     slideInterval() {
        let interval = 3;

        if (this.section.settings && this.section.settings.length) {
            const setting = this.section.settings.find(setting => setting.key === 'slide_interval');
            if (setting && setting.value !== undefined) interval = setting.value;
        }

        return interval * 1000;
    },


    slideWidth() {
      if (this.animation === 'fade') return 100;
      let width = 100;

      const config = this.settings.find(setting => setting.key === 'width');
      if (config) width = parseInt(config.value);

      return width;
    }
  },
  methods: {
    initialize() {
      if (this.$refs.slider) {
        this.flickity = new flickity(this.$refs.slider, {
          autoPlay: this.slideInterval,
          selectedAttraction: this.slideFriction.selectedAttraction,
          friction: this.slideFriction.friction,
          // autoPlay: false,
          wrapAround: true,
          // percentPosition: false,
          // setGallerySize: false,
          pageDots: false,
          fade: this.animation === 'fade'
        });
      }


    },
    handleResize: debounce(function() {
      this.calculateMaxWidth();
    }, 100),
    calculateMaxWidth() {
      if (this.$refs.container) {
        const style = getComputedStyle(this.$refs.container);
        this.width = this.$refs.container.clientWidth;
        this.width -= parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
      }

      this.$nextTick(() => {
        if (!this.flickity) this.initialize();
      });
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
    this.$nextTick(this.calculateMaxWidth);

    this.initialize();
  },
  beforeDestroy() {
    if (this.flickity) this.flickity.destroy();
    window.removeEventListener('resize', this.handleResize);
  }
};
</script>

<style lang="sass" nolang="scss" scoped>
@import "~@/assets/sass/variables"

.slider-container
  .slider
    @apply mx-4 mb-16
  ::v-deep
    .flickity-page-dots
      bottom: 25px
    .flickity-button:focus
      box-shadow: inherit
    .flickity-prev-next-button
      @apply hidden
      top: inherit
      background-color: transparent
      color: var(--color-primary)
      border: 0
      bottom: -64px
      width: 40px
      height: 40px
      &.previous
        left: -10px
      &.next
        right: -10px
  .slide
    background: $skeletonColor
    margin-right: 10px
    height: 200px
    @screen md
      height: 364px
    @screen lg
      height: 492px
    @screen xl
      height: 620px
</style>
